var render = function (_h,_vm) {var _c=_vm._c;return _c('text-field',_vm._g(_vm._b({attrs:{"mask":"#### #######","v-rules":[_vm.parent.$utils.rules.telephone],"value":_vm.props.value}},'text-field',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }